<div class="ag-theme-material grid-wrapper">
  <ag-grid-angular
    [masterDetail]="!!masterDetailEnabled()"
    [detailCellRenderer]="masterDetailCellRenderer()"
    [detailRowAutoHeight]="!!masterDetailRowAutoHeight()"
    (firstDataRendered)="onFirstDataRendered($event)"
    (gridReady)="onGridReady($event)"
    (newColumnsLoaded)="onGridColumnsChanged()"
    (sortChanged)="onSortChanged($event)"
    [colResizeDefault]="'shift'"
    [columnDefs]="columnDefs()"
    [defaultColDef]="defaultColDef"
    [getLocaleText]="getLocaleText"
    [gridOptions]="gridOptions"
    [navigateToNextCell]="navigateToNextCell"
    [navigateToNextHeader]="navigateToNextHeader"
    [rowClassRules]="rowClassRules()"
    [rowData]="rowData()"
    [sideBar]="sideBar"
    [tabToNextCell]="tabToNextCell"
    [tabToNextHeader]="tabToNextHeader"
    style="flex: 1"
  />
  @if (displayPagination()) {
    <grid-engine-paginator [ngClass]="{'ag-max-count-reached': !!pagination()?.maxCountReached }"  (pageChange)="onPageChange($event)" [pagination]="pagination()" />
  }
</div>
<ng-template #exportViewRef />
